export interface TutorialItem {
  id: string;
  title: string;
  summary: string;
  steps: string[];
  badge?: string;
}

export const TUTORIALS: TutorialItem[] = [
  {
    id: "professor-pobre",
    title: "Professor Pobre: como perguntar bem",
    summary: "Use a IA para corrigir e explicar erros em segundos.",
    steps: [
      "Responda a questão normalmente e clique em Professor Pobre",
      "Envie a dúvida com contexto (enunciado + sua resposta)",
      "Peça exemplos, mnemônicos ou resumos curtos se precisar",
    ],
    badge: "IA em segundos",
  },
  {
    id: "estudo-reverso",
    title: "Estudo reverso com questões erradas",
    summary: "Revise pelos erros: comentários, estatísticas e flashcards.",
    steps: [
      "Filtre por 'questões que errei' ou pelo assunto específico",
      "Leia comentários/estatísticas para ver pegadinhas",
      "Gere flashcards ou peça explicação rápida para fixar",
    ],
    badge: "Foque no erro",
  },
  {
    id: "filtros-afiados",
    title: "Filtros afiados (assunto, banca, ano)",
    summary: "Chegue na questão certa mais rápido.",
    steps: [
      "Escolha matéria e tópico; refine por banca/ano recentes",
      "Use busca por palavra-chave para enunciados específicos",
      "Salve o filtro favorito para retomar depois",
    ],
    badge: "+22% acerto médio",
  },
  {
    id: "rotina-diaria",
    title: "Rotina diária: plano + streak",
    summary: "Como usar o plano e manter a constância.",
    steps: [
      "Abra 'O que fazer hoje' e siga a tarefa do dia",
      "Complete a meta diária e mantenha a streak ativa",
      "Feche com 10 questões rápidas + 1 revisão curta",
    ],
    badge: "Constância",
  },
];
